export default "__VITE_ASSET__CsDnQDEk__"